import XLSX from 'xlsx';
import moment from 'moment';

const styleCenter = { // 样式不支持,需要用到xlsx的pro版本,要花几百$,但代码还是写着了,据说可以用xlsx-style代替,但是很久没更新了,就作罢
  alignment: {
    vertical: 'center',
    horizontal: 'center',
  }
};

function exportDeviceXlsx({devicesList}) {
  let sheetData = {
    A1: {v: '设备类别', s: styleCenter},
    B1: { v: '地址', s: styleCenter },
    C1: { v: '设备名称', s: styleCenter },
    D1: { v: '设备型号', s: styleCenter },
    E1: { v: '设备编号', s: styleCenter },
    F1: { v: '生产日期', s: styleCenter },
    G1: { v: '安装日期', s: styleCenter },
    H1: { v: '支持产品', s: styleCenter },
    I1: { v: '日产能/K', s: styleCenter },
    J1: { v: '软件版本', s: styleCenter },
    K1: { v: '状态', s: styleCenter },
    L1: { v: '备注', s: styleCenter },
  };
  let merges = [];
  const baseIndex = 2;
  let nowIndex, rowspan, startR, endR;
  devicesList.map((item, index) => {
    nowIndex = baseIndex + index;
    rowspan = item.rowspan;
    if (rowspan && rowspan > 1) {
      startR = nowIndex - 1; // -1是因为从0开始计数
      endR = nowIndex + rowspan - 2;
      for (let i = 0; i < 12; i++) {
        if (i !== 7 && i !== 8) {
          merges.push({
            s: {
              c: i,
              r: startR,
            },
            e: {
              c: i,
              r: endR,
            }
          });
        }
      }
    }
    sheetData = Object.assign(sheetData, {
      [`A${nowIndex}`]: {v: item.deviceCategoryVal || '', s: styleCenter},
      [`B${nowIndex}`]: {v: item.addr || '', s: styleCenter},
      [`C${nowIndex}`]: {v: item.deviceName || '', s: styleCenter},
      [`D${nowIndex}`]: {v: item.deviceModel || '', s: styleCenter},
      [`E${nowIndex}`]: {v: item.deviceNo || '', s: styleCenter},
      [`F${nowIndex}`]: {v: item.productionDate || '', s: styleCenter},
      [`G${nowIndex}`]: {v: item.installationDate || '', s: styleCenter},
      [`H${nowIndex}`]: {v: item.prod || '', s: styleCenter},
      [`I${nowIndex}`]: {v: item.testDaily || '', s: styleCenter},
      [`J${nowIndex}`]: {v: item.softwareVersion || '', s: styleCenter},
      [`K${nowIndex}`]: {v: item.statusVal || '', s: styleCenter},
      [`L${nowIndex}`]: {v: item.comment || '', s: styleCenter},
    });
  });
  sheetData['!merges'] = merges;
  sheetData['!ref'] = `A1:L${baseIndex + devicesList.length - 1}`;
  sheetData["!cols"] = [{
    wch: 12, // 单元格列的宽度
  }, {
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 15,
  },{
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 15,
  }, {
    wch: 25,
  }];
  const sheetName = 'Sheet1';
  const wb = { SheetNames: [`${sheetName}`], Sheets: {} };
  wb.Sheets[`${sheetName}`] = sheetData;
  const nowDay = moment.utc().local().format('YYYY_MM_DD');
  XLSX.writeFile(wb, `设备列表_${nowDay}.xlsx`);
}

export default exportDeviceXlsx;
